import type { PaletteOptions } from '@mui/material'

export const themePaletteLight: PaletteOptions = {
  mode: 'light',
  base: '#FFFFFF',
  background: {
    default: '#F8FAFB',
    paper: '#FFFFFF',
  },
  primary: {
    main: '#7F56D9',
  },
  secondary: {
    light: '#D5D7DA',
    main: '#414651',
    dark: '#181D27',
  },
  success: {
    main: '#067647',
  },
  grey: {
    50: '#FAFAFA',
    200: '#E9EAEB',
    300: '#D5D7DA',
    400: '#A4A7AE',
    500: '#717680',
    600: '#535862',
    700: '#414651',
    800: '#252B37',
    900: '#181D27',
  },
}

export const themePaletteDark: PaletteOptions = {
  mode: 'dark',
  base: '#000000',
  primary: {
    main: '#9E77ED',
  },
  secondary: {
    light: '#414651',
    main: '#D5D7DA',
    dark: '#181D27',
  },
  grey: {
    50: '#181D27',
    200: '#252B37',
    300: '#414651',
    400: '#535862',
    500: '#717680',
    600: '#A4A7AE',
    700: '#D5D7DA',
    800: '#E9EAEB',
    900: '#F9FAFB',
  },
}
